module.exports = __webpack_public_path__ + "img/288.c1d541ea.jpg";